export const FACEBOOK_LINK = 'https://www.facebook.com/groups/yupwego/';
export const INSTA_LINK = 'https://www.instagram.com/yupwego/';
export const BASE_URL = 'https://www.yupwego.com/';
export const FACEBOOK_SHARE_LINK =
  'https://www.facebook.com/dialog/share?app_id=599798923818468&display=page&href=%CURRENT_URL%&redirect_uri=%CURRENT_URL%';
export const LINKEDIN_SHARE_LINK =
  'https://www.linkedin.com/sharing/share-offsite/?url=%CURRENT_URL%';
